/* Axos brand kit, lifted off the real store and the ad statics.
   Voice rule for every page in this folder: no em dashes anywhere. */

export const A = {
  navy: "#0E2140",
  navyDeep: "#091729",
  ink: "#152B4A",
  body: "#41506A",
  soft: "#7C8AA1",
  blush: "#E98C9E",
  blushDeep: "#D2617A",
  teal: "#3AA6A6",
  tealSoft: "#8ED0CE",
  cream: "#FBF7F2",
  sand: "#F1E8DF",
  line: "#E4D9CE",
  white: "#FFFFFF",
};

export const SERIF = "Spectral, Georgia, serif";
export const SANS = "'Work Sans', system-ui, sans-serif";
export const MONO = "'IBM Plex Mono', ui-monospace, monospace";

export const ADS = {
  quizEntry: "/assets/ads/ad-01.jpg",
  objection: "/assets/ads/ad-02.jpg",
  mechanism: "/assets/ads/ad-03.jpg",
  guessing: "/assets/ads/ad-04.jpg",
  routine: "/assets/ads/ad-05.jpg",
  compare: "/assets/ads/ad-06.jpg",
  guided: "/assets/ads/ad-07.jpg",
  simplified: "/assets/ads/ad-08.jpg",
};

export const SHOTS = {
  hashi:
    "https://www.ibdassist.com/cdn/shop/files/AXOS_Mockup_3.png?v=1781822512&width=800",
  gut: "https://www.ibdassist.com/cdn/shop/files/AXOS_Mockup_4.png?v=1781822512&width=800",
  pair:
    "https://www.ibdassist.com/cdn/shop/files/GUTsupport_and_HashiAid_1_f5137ac8-6d4b-406a-8e5b-3fe1352b6f7f.png?v=1770062038&width=800",
};

export const QUIZ_URL = "https://quiz.ibdassist.com";
export const STORE_URL = "https://www.ibdassist.com/";
